module.exports = __webpack_public_path__ + "static/media/video.5c522fa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyRunnersClub/video.jpg
// module id = 286
// module chunks = 0